<template>
  <div class="userRz">
    <div class="inner">
      <div class="typeContent">
        <p class="title">
          支付结果
        </p>
        <div>
          <div class="innerContent">
            <div class="rzSuccess">
              <img src="../../assets/images/icon_green.png" alt="" class="successImg">
              <p class="t1">
                您已支付成功, 请继续完成签署...
              </p>
              <div class="button active" @click="goOn">继续签署</div>
              <div class="button" @click="$router.push('/')">返回首页</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'paySucc',
    methods: {
      goOn() {
        this.$router.push(`/documentList/5`)
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/less/userRz.css";
  .button{
    width: 160px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    text-align: center;
    color: #000;
    border-radius: 2px;
    cursor: pointer;
    margin: 0 auto 10px;
    border: 1px solid #bbb;
  }
  .button.active{
    color: #fff;
    border: none;
    background-color: #ff9422;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/paySucc.vue